import { Icon } from "@elit-hair/elit-ui";
import { useState } from "react";
import { TbLink } from "react-icons/tb";

import { getIconByName } from "@/components/selectors/icons";

function getFaviconSources(url: string): string[] {
    try {
        const parsed = new URL(url);
        const google = `https://www.google.com/s2/favicons?sz=64&domain_url=${encodeURIComponent(url)}`;
        const duckDuckGo = `https://icons.duckduckgo.com/ip3/${parsed.hostname}.ico`;
        const originIcon = `${parsed.origin}/favicon.ico`;
        const isGoogleHost = parsed.hostname === "google.com" || parsed.hostname.endsWith(".google.com");

        // Sheets, Docs, and Slides share docs.google.com. The full URL picks the product icon.
        // The same lookup returns a generic globe for hosts such as Zoho, so those try another source first.
        if (isGoogleHost) {
            return [google, duckDuckGo, originIcon];
        }

        return [duckDuckGo, originIcon, google];
    } catch {
        return [];
    }
}

export function CustomLinkIcon({ url, iconName }: { url: string; iconName: string | null }) {
    const customIcon = getIconByName(iconName);
    const sources = getFaviconSources(url);
    const [previousUrl, setPreviousUrl] = useState(url);
    const [sourceIndex, setSourceIndex] = useState(0);

    if (previousUrl !== url) {
        setPreviousUrl(url);
        setSourceIndex(0);
    }

    const faviconUrl = sources[sourceIndex];

    if (customIcon) {
        return <Icon icon={customIcon} className="shrink-0" />;
    }

    if (!faviconUrl) {
        return <Icon icon={TbLink} className="shrink-0" />;
    }

    return (
        <img
            src={faviconUrl}
            alt=""
            width={16}
            height={16}
            className="shrink-0 rounded-sm"
            onError={() => setSourceIndex((index) => index + 1)}
        />
    );
}
